import { render, staticRenderFns } from "./CloudStorageImageCarousel.vue?vue&type=template&id=2db497a8&"
import script from "./CloudStorageImageCarousel.vue?vue&type=script&lang=ts&"
export * from "./CloudStorageImageCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCard,VCarousel,VCarouselItem})
